import { AType, summon } from "@silversea-ssc/functional-support"
import { FareCode } from "@silversea-ssc/web-fares-fp"
import { AirFareOption } from "./air-fare-option"
import { VsOption } from "./vs-option"
import { D2DOption } from "./d2d-option"
import { Gateway } from "./gateway"
import { PromoOption } from "./promo-option"

export const SingleFareOptions = summon((F) =>
    F.interface(
        {
            fareCode: FareCode(F),
            vs: F.nullable(VsOption(F)),
            airFares: F.array(AirFareOption(F)),
            gateways: F.array(Gateway(F)),
            d2d: F.nullable(D2DOption(F)),
            promotions: F.array(PromoOption(F)),
        },
        "SingleFareOptions",
    ),
)
export type SingleFareOptions = AType<typeof SingleFareOptions>
